function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 9.66l-.037.003a.517.517 0 00-.3.14l-2.02 2.02a2.26 2.26 0 01-1.609.662 2.26 2.26 0 01-2.272-2.272c0-.61.235-1.182.663-1.61L4.319 6.46a2.262 2.262 0 011.606-.663c.044 0 .088.003.144.006a2.27 2.27 0 011.462.657c.24.24.425.534.535.853.087.25.35.39.603.315.003 0 .006-.003.01-.003.002 0 .005 0 .005-.003a.488.488 0 00.329-.597 2.832 2.832 0 00-.77-1.281 3.29 3.29 0 00-2.324-.96 3.151 3.151 0 00-.747.088c-.035.006-.066.016-.1.025a3.25 3.25 0 00-1.475.85L1.453 7.891A3.296 3.296 0 00.5 10.219 3.272 3.272 0 003.781 13.5c.881 0 1.706-.34 2.325-.96l2.04-2.04a.495.495 0 00-.396-.84z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.541 1.46A3.261 3.261 0 0010.22.5c-.878 0-1.706.34-2.325.96l-1.99 1.99a.502.502 0 00.315.856c.147.013.291-.04.397-.144L8.61 2.175c.428-.428 1-.662 1.61-.662a2.259 2.259 0 012.271 2.271 2.26 2.26 0 01-.662 1.61L9.685 7.537A2.261 2.261 0 018.08 8.2c-.044 0-.09-.003-.144-.006a2.27 2.27 0 01-1.462-.657 2.25 2.25 0 01-.513-.796.505.505 0 00-.95.334c.14.438.378.81.74 1.172l.007.006a3.29 3.29 0 002.569.95 3.25 3.25 0 002.078-.95l2.144-2.144c.618-.618.959-1.443.959-2.325a3.27 3.27 0 00-.966-2.325z"
});

function SvgWebLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgWebLink;